const doc = [({"en":({"js":({"agenda_item_elements":({"edit":({"image":({"choose_image_file":"Choose imagefile"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;